import usePaymentEntitiesQuery from '@/buyer-portal/components/features/listing/hooks/usePaymentEntitiesQuery'

/**
 * Eagerly fetches payment entities for the current user so the data is
 * already in cache when needed for inline bidding.
 */
const PaymentEntitiesPrefetcher = () => {
  usePaymentEntitiesQuery()
  return null
}

export default PaymentEntitiesPrefetcher
